import {
  Component,
  Inject,
  Injector,
  LOCALE_ID,
  NgZone,
  OnInit,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TuiAlertService, TuiDialogService } from "@taiga-ui/core";
import { PolymorpheusComponent } from "@tinkoff/ng-polymorpheus";
import * as moment from "moment";
import { ApiService } from "src/app/core/services/shared/api.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { NotificationService } from "src/app/core/services/shared/notification.service";
import { CodehelpService, LoginInfo } from "virtue-form";
import { DemoUserIntroComponent } from "../../shared/dialog/demo-user-intro/demo-user-intro.component";
import { ExtendloginaccountComponent } from "../../shared/dialog/extendloginaccount/extendloginaccount.component";
export class Student {
  public firstName: string;
  public email: string;
  public lastName: string;
  public coupon: string;
  public priceId: string;
}

export class studentLogin {
  public name: string;
  public pass: string;
  public extenddate: number = 1;
}

@Component({
  selector: "app-demouser",
  templateUrl: "./demouser.component.html",
  styleUrls: ["./demouser.component.scss"],
})
export class DemouserComponent implements OnInit {
  model = new Student();
  isApplyCouponCode: boolean = false;
  validitionlastName: string;
  validitionfirstName: string;
  activeItemIndex = 0;
  studentLogin = new studentLogin();
  isValidField: boolean = false;
  showLoader: boolean = false;
  verifyshowLoader: boolean = false;
  alreadyAccount: boolean = true;
  verifyotp: string = "";
  Studenttext: string = "Sign in";
  IsAddclass: boolean = true;
  isExpireLogin = false;
  validitionUSerName: String = "";
  validitionUSerPass: String = "";
  selectedPrice: string = "";
  extendLoginObj: any = "";
  hide: boolean = true;
  IsLoadData: boolean = false;
  otpmatch: string = "12345";
  emailvalidate: boolean = true;
  constructor(
    public apiService: ApiService,
    private route: ActivatedRoute,
    private codehelp: CodehelpService,
    private zone: NgZone,
    private router: Router,
    public globalvar: GlobalVarService,
    private notificatioService: NotificationService,
    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector,
    @Inject(TuiAlertService)
    private readonly alertService: TuiAlertService,
    @Inject(LOCALE_ID) private locale: string
  ) {}
  otp: boolean = false;
  emailvalidation: boolean = false;
  isDisabledCouponCode = false;
  Name: boolean = false;
  Coupon: boolean = false;
  signup: boolean = false;
  otpvalidation: boolean = false;
  validationseen: string;
  validitionseenname: string;
  validitionseencoupon: string;
  validationseenotp: string;
  productKey: any;
  WithoutCoupenCode: string;
  PriceList: any[] = [];
  hasReloaded: boolean = false;
  ngOnInit(): void {
    //  this.reloadPage();

    this.route.queryParams.subscribe((params) => {
      // window.location.reload();
      this.getProductKey();
      if (params?.org) {
        let accessKey = params?.org.replace(/[^a-zA-Z0-9 ]/g, "");
        // let accessKey = params.org.replace(/[^a-zA-Z ]/g, "");

        if (accessKey != "" && accessKey != undefined) {
          this.getOrganizationbyAccessKey(accessKey);
        }
      } else {
        this.getOrganizationbyAccessKey("top5");
      }

      if (params?.couponCode != undefined) {
        let cop = params.couponCode.replace(/[^a-zA-Z ]/g, "");
        if (cop == "WALLIN") {
          this.activeItemIndex = 1;
          this.isDisabledCouponCode = true;
          this.model.coupon = "WALLIN";
          //this.getProductKey();
        }
        const couponCode = params["couponCode"];
        if (couponCode === "withoutCoupon") {
          this.WithoutCoupenCode = couponCode;
          //this.getProductKey();
        }
      } else {
        this.studentautofill(params.query);
      }
    });

    this.getProductKey();
  }
  // reloadPage(): void {
  //   // Check if the page hasn't been reloaded yet
  //   if (!this.hasReloaded) {
  //     // Set the flag to true to prevent future reloads
  //     this.hasReloaded = true;

  //     // Perform the reload or your custom logic
  //     window.location.reload();
  //   }
  // }

  getOrganizationbyAccessKey(accessKey: string) {
    this.globalvar.isLoading = true;
    this.apiService.getOrganizationByOrgAccessKey(accessKey).then((res) => {
      if (res) {
        this.globalvar.orgRef = res;
      }
    });
  }
  getProductKey() {
    this.apiService.getProductKeyForStudent((res) => {
      if (res) {
        this.apiService.getpriceList(res.productId).then((resp: any) => {
          this.PriceList = resp;
          this.model.priceId = this.PriceList[0].priceStripeId;
          this.selectedPrice = this.PriceList[0].priceStripeId;
        });
        this.productKey = res;
      }
    });
  }
  AllData(priceid: any) {
    this.selectedPrice = priceid;
    this.model.priceId = priceid;
  }
  Agree: boolean = false;
  agreeCoupon() {
    this.Agree = !this.Agree;
  }
  studentautofill(data) {
    if (data) {
      const decodedStringAtoB = atob(data);
      const splitdecoded = decodedStringAtoB.split("=");
      const password = splitdecoded[2];
      const email = splitdecoded[1];
      const emailsplit = email?.split("&");
      this.studentLogin.name = emailsplit[0];
      this.studentLogin.pass = password;
      let formdata = {
        username: this.studentLogin.name,
        password: this.studentLogin.pass,
      };
      this.setLoginForm(formdata);
    }
  }

  setLoginForm(data) {
    this.verifyshowLoader = true;
    this.onLogin(data);
  }
  // vailidatFields() {
  //   if (
  //     this.model.name == "" ||
  //     this.model.email == "" ||
  //     !this.model.email.match("^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$") ||
  //     !this.model.name.match("[a-zA-Z][a-zA-Z ]*")
  //   ) {
  //     if (this.model.name == "") {
  //       this.isValidField = false;
  //       this.notificatioService.showNotification(
  //         "Please enter student's name.",
  //         "Fill",
  //         true,
  //         "error"
  //       );
  //       return false;
  //     }

  //     if (this.model.email == "") {
  //       this.isValidField = false;
  //       this.notificatioService.showNotification(
  //         "Please enter email ID.",
  //         "Fill",
  //         true,
  //         "error"
  //       );
  //       return false;
  //     }
  //     if (!this.model.email.match("^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$")) {
  //       this.isValidField = false;
  //       this.notificatioService.showNotification(
  //         "Please enter valid email format.",
  //         "Fill",
  //         true,
  //         "error"
  //       );
  //       return false;
  //     }

  //     if (!this.model.name.match("[a-zA-Z][a-zA-Z ]*")) {
  //       this.isValidField = false;
  //       this.notificatioService.showNotification(
  //         "Please enter valid student's name format.",
  //         "Fill",
  //         true,
  //         "error"
  //       );
  //       return false;
  //     }

  //     return false;
  //   } else {
  //     this.isValidField = false;
  //     return true;
  //   }
  // }

  vailidatFields1() {
    if (this.studentLogin.name == "" || this.studentLogin.pass == "") {
      if (this.studentLogin.name == "") {
        this.isValidField = false;
        this.notificatioService.showNotification(
          "Please enter user Name.",
          "Fill",
          true,
          "error"
        );
        return false;
      }

      // if (!this.studentLogin.name.match('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$') ) {
      //   this.isValidField = false;
      //   this.notificatioService.showNotification(
      //     'Please enter valid email format.',
      //     'Fill',
      //     true,
      //     'error'
      //   );
      //   return false;
      // }

      // if (!this.model.name.match('^[a-zA-Z]+$') ) {
      //   this.isValidField = false;
      //   this.notificatioService.showNotification(
      //     'Please enter valid Name format.',
      //     'Fill',
      //     true,
      //     'error'
      //   );
      //   return false;
      // }

      return false;
    } else {
      this.isValidField = false;
      return true;
    }
  }
  // submit(data) {
  //   if (data.valid) {
  //     this.showLoader = true;
  //     // this.otp = true;

  //     if (this.isDisabledCouponCode == true) {
  //       data.value.coupon = this.model.coupon;
  //     }

  //     this.apiService.couponValidation(data.value).then(
  //       (resp: any) => {
  //         if (resp) {
  //           this.showLoader = false;
  //           if (resp.EMAIL_ALREADY_EXIST == "TRUE") {
  //             this.notificatioService.showNotification(
  //               "Email id already exits.",
  //               "Already exits",
  //               true,
  //               "warning"
  //             );
  //           }
  //           if (resp.MAIL_SENT_STATUS == "MAIL_WITH_CREDENTIALS_SENT") {
  //             this.activeItemIndex = 0;
  //             this.alreadyAccount = true;
  //             this.Studenttext = "Sign in";
  //             this.otp = true;
  //             this.studentLogin.name = this.model.email;
  //             this.studentLogin.pass = "";
  //             this.notificatioService.showNotification(
  //               "We have sent username and password to given email address.",
  //               "Send mail",
  //               true,
  //               "success"
  //             );
  //           }
  //           if (resp.COUPON_VALIDITY == "COUPON_CODE_IS_INVALID") {
  //             this.notificatioService.showNotification(
  //               "Please enter valid coupon code.",
  //               "Invalid coupon code",
  //               true,
  //               "warning"
  //             );
  //           }
  //         }
  //       },

  //       (error) => {
  //         if (error.status == "500" || error.status) {
  //           this.showLoader = false;
  //           console.log("couponValidation", error.status);
  //         }
  //       }
  //     );
  //   }
  // }
  submit(data) {
    if (data.valid) {
      console.log(this.model.priceId, "Prieid");
      this.showLoader = true;
      // this.otp = true;
      // if (this.isDisabledCouponCode == true) {
      //   data.value.coupon = this.model.coupon;
      // }

      if (this.model.coupon) {
        data.value.coupon = this.model.coupon;
      }
      if (this.model.priceId) {
        data.value.priceId = this.model.priceId;
      }

      if (this.model.coupon === "" || this.model.coupon == undefined) {
        this.isApplyCouponCode = false;
      } else {
        this.isApplyCouponCode = true;
      }

      this.apiService
        .signUpForSubscriptionPaymentStudent(
          data.value,
          this.isApplyCouponCode,
          this.productKey.productId
        )
        .then(
          (resp: any) => {
            if (resp) {
              if (resp.created == true) {
                if (resp?.linkUrl == null && resp?.errorMsg == null) {
                  this.notificatioService.showNotification(
                    "You've been successfully registered to the tool.The credentials have been shared to your registered e-mail.",
                    "Create User",
                    true,
                    "success"
                  );
                } else {
                  if (resp.errorMsg == "COUPON_CODE_IS_INVALID") {
                    this.notificatioService.showNotification(
                      "Please enter valid coupon code.",
                      "Invalid coupon code",
                      true,
                      "warning"
                    );
                  } else {
                    if (resp?.linkUrl && resp?.errorMsg == null) {
                      // window.open(resp?.linkUrl);
                      window.open(resp?.linkUrl, "_blank");
                      // window.open(resp?.linkUrl, "_self");
                    } else {
                      if (resp?.linkUrl == null && resp?.errorMsg) {
                        this.notificatioService.showNotification(
                          resp?.errorMsg,
                          "Already Exists",
                          true,
                          "success"
                        );
                      }
                    }
                  }
                }
              } else {
                if (
                  resp?.linkUrl == null &&
                  resp.errorMsg == "COUPON_CODE_IS_INVALID"
                ) {
                  this.notificatioService.showNotification(
                    "Please enter valid coupon code.",
                    "Invalid coupon code",
                    true,
                    "warning"
                  );
                } else {
                  if (resp?.linkUrl == null && resp?.errorMsg) {
                    this.notificatioService.showNotification(
                      resp?.errorMsg,
                      "Already Exists",
                      true,
                      "warning"
                    );
                  }
                }
              }

              this.showLoader = false;
            }
          },
          (error) => {
            if (error.status == "500" || error.status) {
              this.showLoader = false;
            }
          }
        );
    }
  }
  verifysubmit(data) {
    if (data.valid) {
      this.verifyshowLoader = true;
      // if(this.otpmatch == data.value.otp){

      const userName = this.model.email;
      const userPassword = this.verifyotp;
      // let formdata1 = {
      //   username: "syed.ali@virtueanalytics.com",
      //   password: "q9CdF12n",
      // };
      let formdata = {
        username: userName,
        password: userPassword,
      };

      this.onLogin(formdata);
    }
  }

  diff(start, end) {
    start = start.split("-");
    end = end.split("-");
    var startDate = new Date(0, 0, 0, start[0], start[1], 0);
    var endDate = new Date(0, 0, 0, end[0], end[1], 0);
    var diff = endDate.getTime() - startDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);

    // If using time pickers with 24 hours format, add the below line get exact hours
    if (hours < 0) hours = hours + 24;

    return (
      (hours <= 9 ? "0" : "") +
      hours +
      ":" +
      (minutes <= 9 ? "0" : "") +
      minutes
    );
  }
  toHoursAndMinutes(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return { hours, minutes };
  }
  diff_minutes(dt2, dt1) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  }

  onLogin(formdata: any) {
    this.codehelp.resetUserInfoLogout();
    this.verifyshowLoader = true;
    this.apiService.login(JSON.stringify(formdata)).then(
      (resp: LoginInfo) => {
        const currentDate = new Date();
        // var todayDate = moment(currentDate).format("YYYY-MM-DD");
        // var expiredate = moment(resp.expireOnTime).format("YYYY-MM-DD");
        var todayDate = moment(currentDate).utc();
        var expiredate = moment(resp.expireOnTime);
        if (todayDate > expiredate) {
          this.isExpireLogin = true;

          this.extendLoginObj = {
            username: this.studentLogin.name,
            password: this.studentLogin.pass,
            extendDay: "1",
          };
          this.verifyshowLoader = false;
        } else {
          this.codehelp.setStoreValue("LoginInfo", JSON.stringify(resp));
          this.codehelp.setAuthToken(resp.accessToken);
          this.globalvar.loginToken = resp.accessToken;
          this.apiService.loggedInInfo().then((loggedUser) => {
            if (loggedUser) {
              //  let ServiceUrlProviderId = this.codehelp.getProviderID();
              this.codehelp.setLoggedUserDetail(JSON.stringify(loggedUser));
              this.apiService
                .getUesrProfileData(loggedUser?.mappedTo.id)
                .then((userProfile) => {
                  this.codehelp.setUserProfile(JSON.stringify(userProfile));
                  // if (ServiceUrlProviderId == loggedUser?.orgRef?.id) {

                  this.isExpireLogin = false;
                  // const er = new Date(resp.expireOnTime);
                  // let hours = moment(resp.expireOnTime).diff(
                  //   moment().utc(),
                  //   "hours"
                  // );
                  // var hours=moment().utc().diff(moment(resp.expireOnTime),'hours');
                  // let hr=moment().utc().diff(moment(resp.expireOnTime),'hours');
                  // console.log("hr", hours);

                  this.codehelp.setStoreValue(
                    "LoginSessionHoure",
                    resp.expireOnTime
                  );
                  //this.globalvar.TimeDiffrence = hours;
                  this.codehelp.setStoreValue("LoginUserFrom", "DemoStudent");
                  this.router.navigate(["/home/steps/0"]);
                  this.verifyshowLoader = false;
                  let loginIfo = JSON.parse(
                    this.codehelp.getStoreValue("LoginInfo")
                  );
                  if (loginIfo?.ShowTutorial == true) {
                    this.dialogMailme = this.dialogService.open<any>(
                      new PolymorpheusComponent(
                        DemoUserIntroComponent,
                        this.injector
                      ),
                      {
                        data: {},
                        dismissible: false,
                        size: "l",
                      }
                    );
                    this.dialogMailme.subscribe({
                      next: (data) => {},
                    });
                  }

                  // this.router.navigate([this.globalvar.basepath + "/home/steps/0",]);
                });
            }
          });
        }
      },
      (error) => {
        if (error.status == "500" || error.status) {
          this.verifyshowLoader = false;
          this.isExpireLogin = false;
          this.notificatioService.showNotification(
            "Please enter valid username and password.",
            "Invalid User",
            true,
            "warning"
          );
        }
      }
    );
  }

  handlename(arg) {
    if (arg.target.value == "") {
      this.validitionseenname = "Student's name is required";
      this.Name = true;
    }
    if (arg.target.value) {
      this.validitionseenname = "";
      this.Name = false;
      const res = arg.target.value.match("[a-zA-Z][a-zA-Z ]*");
      const a = res?.toString();
      if (res === null) {
        this.validitionseenname = "Please enter valid student's name";
        this.Name = true;
      }
      if (arg.target.value == a) {
        this.Name = false;
      }
      if (arg.target.value != a) {
        this.validitionseenname = "Please enter valid student's name";
        this.Name = true;
      }
    }
  }

  handleuserNAme(arg) {
    if (arg.target.value == "") {
      this.validitionUSerName = "Student user name is required";
    } else {
      this.validitionUSerName = "";
    }
  }
  handleuserPassword(arg) {
    if (arg.target.value == "") {
      this.validitionUSerPass = "Student password is required";
    } else {
      this.validitionUSerPass = "";
    }
  }

  handleuserNAmeValue(event) {
    // var charCode = event.which ? event.which : event.keyCode;

    if (event.code === "Space") {
      event.preventDefault();
      return false;
    }
    // console.log(charCode);
    // if (charCode != 32) {
    //   event.preventDefault();
    //   return false;
    // }
    return true;
  }

  handleEmail(arg) {
    if (arg.target.value == "") {
      this.validationseen = "Students's email is required";
      this.emailvalidation = true;
    }
    if (arg.target.value) {
      const res = arg.target.value.match(
        "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
      );
      const a = res?.toString();
      if (res === null) {
        this.validationseen = "Please enter valid students's email format";
        this.emailvalidation = true;
      }
      if (arg.target.value == a) {
        this.emailvalidation = false;
        this.validationseen = "";
      }
      if (arg.target.value != a) {
        this.validationseen = "Please enter valid students's email format";
        this.emailvalidation = true;
      }
    }
  }

  handlecoupon(arg) {
    if (arg.target.value == "") {
      this.validitionseencoupon = "Coupon code is required";
      this.Coupon = true;
    }
    if (arg.target.value) {
      this.Coupon = false;
    }
  }

  handleotp(arg: any) {
    if (arg.target.value == "") {
      this.validationseenotp = "Access code is required";
    }
    if (arg.target.value) {
      this.validationseenotp = "";
    }
  }

  accountLogin(data) {
    if (data.valid) {
      this.globalvar.isShowLogin = true;
      this.verifyshowLoader = true;
      let formdata = {
        username: this.studentLogin.name,
        password: this.studentLogin.pass,
      };
      this.onLogin(formdata);
    }
  }

  private dialogMailme = this.dialogService.open<any>(
    new PolymorpheusComponent(DemoUserIntroComponent, this.injector),
    {
      data: {},
      dismissible: true,
      closeable: false,
      label: "",
      size: "s",
    }
  );

  privacypolicy() {
    // let demoLink = "https://calendly.com/virtueanalytics/30min";
    // let demoLink = "https://outlook.office.com/bookwithme/?%2fjatin&anonymous";
    let privacypolicyLink = "https://www.top5colleges.us/privacy-policy/";
    window.open(privacypolicyLink, "_blank");
  }
  applyCoupon(event: any) {
    if (event.target.checked) {
      this.isApplyCouponCode = true;
    } else {
      this.isApplyCouponCode = false;
    }
  }
  coupencode(event: any) {
    if (event.target.value == true) {
      this.model.priceId = "";
    } else {
      this.model.priceId = this.PriceList[0].priceStripeId;
    }
  }

  onRadioChange(data: any) {
    this.model.priceId = data.priceStripeId;
    this.selectedPrice = data.priceStripeId;
  }

  disabledbtn() {
    if (
      this.model.email == "" ||
      this.model.firstName == "" ||
      this.model.lastName == "" ||
      this.model.coupon == ""
    ) {
      return true;
    }
    if (
      this.model.email == undefined ||
      this.model.firstName == "" ||
      this.model.lastName == "" ||
      this.model.coupon == undefined
    ) {
      return true;
    }
  }
  getPriceLabel(label: string) {
    if (label == "month") {
      return "Monthly";
    }
    if (label == "year") {
      return "Annual";
    }
  }

  disabledbtn1() {
    if (this.studentLogin.name == "" || this.studentLogin.pass == "") {
      return true;
    }
    if (
      this.studentLogin.name == undefined ||
      this.studentLogin.pass == undefined
    ) {
      return true;
    }

    // if (this.studentLogin.name != "" || this.studentLogin.name != undefined) {
    //   if (!this.studentLogin.name.match("^[A-Za-z0-9]+[_@0-9a-zA-Z.]*")) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }
  }

  disabledverify() {
    if (this.verifyotp == "" || this.verifyotp == undefined) {
      return true;
    }
  }

  previous() {
    this.otp = false;
  }

  // handleInput(event: any) {
  //   // if(event.target.value == ''){
  //   //   this.validitionseenname = "Student's name is required";
  //   //   return true;
  //   // }
  //   // else{
  //     this.validitionseenname = "";
  //     var charCode = event.which ? event.which : event.keyCode;
  //     console.log(charCode);
  //     if (
  //       (charCode < 65 || charCode > 90 ||
  //         charCode <= 97 || charCode > 122 || charCode ==32)) {
  //       event.preventDefault();
  //       return false;
  //     }
  //     return true;
  //  // }
  // }

  handleInput(event: any) {
    var charCode = event.which ? event.which : event.keyCode;
    if (
      (charCode >= 48 || charCode <= 57) &&
      (charCode < 65 || charCode > 90) &&
      (charCode < 97 || charCode > 122) &&
      (charCode > 32 || charCode > 48)
    ) {
      event.preventDefault();
      return false;
    }
    return true;
  }
  onClickAccount() {
    this.otp = false;
    this.studentLogin.name = "";
    this.alreadyAccount = !this.alreadyAccount;
  }
  openModelExtend() {
    // let extenddayform = {
    //   username: this.studentLogin.name,
    //   password: this.studentLogin.pass,
    //   extendDay: "1",
    // };
    if (this.extendLoginObj) {
      this.apiService.extendday(this.extendLoginObj).then((res) => {
        {
          if (res) {
            this.opendialog = this.dialogService.open<any>(
              new PolymorpheusComponent(
                ExtendloginaccountComponent,
                this.injector
              ),
              {
                data: {},
                dismissible: false,
              }
            );
            this.opendialog.subscribe({
              next: (data) => {
                if (data == true) {
                  this.isExpireLogin = false;
                }
              },
              complete: () => {},
            });
          }
        }
      });
    }
  }

  private opendialog = this.dialogService.open<any>(
    new PolymorpheusComponent(ExtendloginaccountComponent, this.injector),
    {
      data: "",
      dismissible: false,
      size: "l",
    }
  );
  showData(tabs: any) {
    if (tabs == "tab2") {
      this.Studenttext = "Sign in";
      this.alreadyAccount = false;
    }
    if (tabs == "tab1") {
      this.Studenttext = "Sign up";
      this.alreadyAccount = true;
    }
  }
  handleuserfirst(arg) {
    if (arg.target.value == "") {
      this.validitionfirstName = "Student's First Name is required";
    } else {
      this.validitionfirstName = "";
    }
  }

  handleuserlast(arg) {
    if (arg.target.value == "") {
      this.validitionlastName = "Student's Last Name is required";
    } else {
      this.validitionlastName = "";
    }
  }
  showPriceList = true;

  onCouponCodeInput() {
    // Check if appliedCouponCode is not empty
    this.isApplyCouponCode = this.model.coupon.trim() !== "";
    this.showPriceList = !this.isApplyCouponCode;
  }
}
